import React, { Component } from 'react';
import cx from 'classnames';
import Dropzone from 'react-dropzone'
import axios from 'axios';
import { alertError } from 'utils/alert';
import config from 'config';

import './UploadLogo.css';

// NOTE: Taken from WEB repo and modified very slightly.
const imageUploader = ({ data, filename, filetype }, { model, id, type, endpoint }) => {
  let designatedUrl = '';
  let signatureEndpoint = '';
  if (model && id) {
    signatureEndpoint = `${model}/${id}/${type}-upload-signature/`;
  }
  else {
    signatureEndpoint = endpoint;
  }

  const accessToken = localStorage.getItem('accessToken').replace(/"/g, '') || '';
  return axios.get(`${config.API_URL}/${signatureEndpoint}`, {
    params: {
      filename,
      filetype,
    },
    headers: { authorization: accessToken },
  })
    .then((response) => {
      const { signed_request } = response.data;
      designatedUrl = response.data.url;
      const options = {
        withCredentials: false,
        headers: {
          'Content-Type': filetype,
          'Cache-Control': 'max-age=604800',
        },
      };

      // signed_request is the s3 URL that files are to be sent to
      // url is the URL that the image will be available at if an image
      // is uploaded to the signed_request
      return axios.put(signed_request, data, options);
    })
    .then(() => designatedUrl);
};

class UploadLogo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      file: {},
      loading: false,
    };
  }

  onDrop = (acceptedFiles, rejectedFiles) => {
    if (acceptedFiles.length) {
      this.setState({
        file: acceptedFiles[0],
      }, () => this.handleUpload(this.state.file));
    }
  }

  handleUpload = (data) => {
    this.setState({
      loading: true,
    });

    const { model, id, type, onChange } = this.props;

    imageUploader({
      data,
      filename: this.state.file.name,
      filetype: this.state.file.type,
    },
    { model, id, type })
      .then((designatedUrl) => {
        onChange(designatedUrl);
        this.setState({ newUrl: designatedUrl });
      })
      .then(() => {
        // NOTE: This setTimeout is required because even though the mutation is complete,
        // the file takes few seconds to become available on imgix, so we want to show the
        // loader for a few seconds longer.
        window.setTimeout(() => {
          this.setState({ loading: false });
        }, 3000);
      })
      .catch((error) => {
        alertError(error);
        this.setState({ loading: false });
      });
  }

  render() {
    const { file } = this.state;

    return (
      <Dropzone onDrop={this.onDrop}>
        {({getRootProps, getInputProps, isDragActive}) => {
          return (
            <div
              {...getRootProps()}
              className={cx('dropzone', 'UploadLogo', {'dropzone--isActive': isDragActive})}
            >
              <input {...getInputProps()} />
              {file.name && <p><b>Selected logo: {file.name}</b></p>}
              {
                isDragActive ?
                <p>Drop group logo here...</p>
                :
                <p>Drag & drop group logo here or click here to select group logo.</p>
              }
            </div>
          );
        }}
      </Dropzone>
    );
  }
}


export default UploadLogo;
